<a
  #contextMenu
  class="search-result-item justify-stretch"
  (click)="handleClick(item())"
  [routerLink]="searchUrl"
  (contextmenu)="handleContextMenu(item())"
  [class.loading]="isLoading()"
  [class.selected]="isSelected()"
>
  <div class="flex items-center px-1">
    <div class="text-base font-semibold px-2">
      <i [class]="getIconClass()"></i>

      {{ item().title }}
    </div>
    @if (item().subTitle) {
      <div class="text-sm px-1">
        {{ item().subTitle }}
      </div>
    }

    @if (!GLOBAL_SEARCH_MODEL_HIDDEN_STATUSES.includes(item().model)) {
      <!--pfx-global-search-result-status-badge [item]="item()"></pfx-global-search-result-status-badge-->
    }
  </div>

  <div class="right-side">
    <div class="text-sm">
      {{ item().createdAt | date: 'dd.MM.yyyy' }}
    </div>
    <pfx-icon
      [icon]="faArrowTurnDownLeft"
      class="enter-icon"
    ></pfx-icon>
    @if (isHistoryItem()) {
      <button
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-plain delete-button"
        (click)="handleDelete($event)"
      ></button>
    }
  </div>
</a>
